import { EntityTypeId } from './entity/EntityTypeId.enum'
import type { EntityTypeMeta } from './EntityTypeMeta'


export default function isEntityTypeMetaUnit(etm: EntityTypeMeta) {
  return etm.id >= EntityTypeId.Infantry
}
